<template>
<div class="modalContents__object06" data-modalContents="signup04">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
                <h2 class="text-center">MEMBERSHIP INFO.</h2>
                <form id="signup04_form" class="row no-gutters"  @submit.prevent="send">
                    <!-- 登録者情報 -->
                    <h3 class="col-12">■ 登録者情報（登録内容をご確認ください）</h3>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-3">お名前</dt>
                        <dd class="col-9" id="signup_confirm_name">{{ $store.state.inputData.last_name }} {{ $store.state.inputData.first_name }}</dd>
                        <dt class="col-3">MAIL</dt>
                        <dd class="col-9" id="signup_confirm_email">{{ $store.state.inputData.email }}</dd>
                        <dt class="col-3">TEL</dt>
                        <dd class="col-9" id="signup_confirm_phone">{{ $store.state.inputData.phone }}</dd>
                        <dt class="col-3">パスワード</dt>
                        <dd class="col-9" id="signup_confirm_password">＊＊＊＊＊＊＊＊＊＊</dd>
                        <dt class="col-3">生年月日</dt>
                        <dd class="col-9" id="signup_confirm_birthday">{{ dispBirthday() }}</dd>
                        <dt class="col-3">性別</dt>
                        <dd class="col-9" id="signup_confirm_gender">{{ dispGender() }}</dd>
                    </dl>
                    <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                        <button class="text-center btn modalContents__object06--change globalModal--btn" data-modal="signupChange01"
                            type="submit">修正</button>
                    </div> -->
                    <!-- プラン内容 -->
                    <h3 class="col-12">■ プラン内容（登録内容をご確認ください）</h3>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-3">視聴プラン</dt>
                        <dd class="col-9" id="signup_confirm_plan">{{ dispPlan() }}</dd>
                        <dt class="col-3">メールマガジン</dt>
                        <dd class="col-9" id="signup_confirm_mm01">「ニッポンの問題点」を購読{{ $store.state.inputData.mm01 ? 'する' : 'しない' }}</dd>
                        <dt class="col-3">メールマガジン</dt>
                        <dd class="col-9" id="signup_confirm_mm02">「読むオプエド」を購読{{ $store.state.inputData.mm02 ? 'する' : 'しない' }}</dd>
                    </dl>
                    <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                        <button class="text-center btn modalContents__object06--change globalModal--btn" data-modal="signupChange02"
                            type="submit">修正</button>
                    </div> -->
                    <!-- お支払い方法 -->
                    <!-- 支払い方法によって以下のどちらか（カード支払いの情報か銀行支払いの情報）を表示するようにしてください -->
                    <!-- カード支払いの場合 -->
                    <div class="col-12" id="signup_confirm_credit" v-if="$store.state.inputData.payment_type == 'credit'">
                        <div class="row no-gutters">
                            <h3 class="col-12">■ お支払い方法（登録内容をご確認ください）</h3>
                            <dl class="col-12 row no-gutters">
                                <dt class="col-3">決済方法</dt>
                                <dd class="col-9">PAY.jp 定期課金</dd>
                                <!-- 消費税込みの金額が表示されるようにしてください -->
                                <dt class="col-3">ご請求額(税込)</dt>
                                <dd class="col-9" id="signup_confirm_credit_price">{{ dispCreditPrice() }}円</dd>
                            </dl>
                            <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                                <button class="text-center btn modalContents__object06--change globalModal--btn"
                                    data-modal="signupChange03" type="submit">修正</button>
                            </div> -->
                        </div>
                    </div>

                    <!-- 銀行支払いの場合 -->
                    <div class="col-12" id="signup_confirm_bank" v-if="$store.state.inputData.payment_type == 'bank'">
                        <div class="row no-gutters">
                            <h3 class="col-12">■ お支払い方法（登録内容をご確認ください）</h3>
                            <dl class="col-12 row no-gutters">
                                <dt class="col-3">決済方法</dt>
                                <dd class="col-9">銀行振込</dd>
                                <dt class="col-3">振込名義人</dt>
                                <dd class="col-9" id="signup_confirm_bank_name">{{ $store.state.inputData.bank_name }}</dd>
                                <dt class="col-3">ご契約期間</dt>
                                <dd class="col-9" id="signup_confirm_bank_month">{{ $store.state.inputData.bank_month }}ヵ月</dd>
                                <!-- 消費税込みの金額が表示されるようにしてください -->
                                <dt class="col-3">ご請求額(税込)</dt>
                                <dd class="col-9" id="signup_confirm_bank_price">{{ dispBankPrice() }}円</dd>
                            </dl>
                            <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                                <button class="text-center btn modalContents__object06--change globalModal--btn"
                                    data-modal="signupChange03" type="submit">修正</button>
                            </div> -->
                        </div>
                    </div>

                    <p class="col-12">ご入力頂いた個人情報は「<a href="/privacy-policy.html" target="_blank">プライバシーポリシー</a>」の記載に基づいて適切に管理します。<br>ご利用にあたり、「<a href="/policy.html" target="_blank">利用規約</a>」を必ずご確認ください。<br>「プライバシーポリシー」及び「利用規約」に同意の上、入力情報を送信して下さい。</p>
                    <div class="col-12 form-check modalContents__object06--privacy">
                        <input type="checkbox" name="privacy_check" id="privacy_check" v-model="privacy_check">
                        <label for="privacy_check">プライバシーポリシー及び利用規約に同意する</label>
                    </div>
                    <div class="col-12">
                        <button id="signup_submit" class="text-center btn modalContents__object06--submit globalModal--btn"
                            data-modal="signupSubmit" type="submit" style="opacity:0.5">登録</button>
                    </div>

                    <ul class="col-12 row no-gutters">
                        <li class="col-12">「登録」ボタンは1度だけクリックしてください。<br>複数回クリックすると有料プランの場合重複して決済されてしまう可能性があります。<br>次の画面に移動する間にブラウザを閉じたり、ブラウザの「戻る」ボタンをクリックしないでください。</li>
                        <li class="col-12"><strong>表示金額は税込の金額</strong>になります。</li>
                        <li class="col-12">カード決済を選択された場合、毎月1日の決済となります。</li>
                        <li class="col-12">銀行振込を選択された場合、ブロンズ会員以上のお申し込みの方には、ご登録後に<strong>お振込方法などを詳しく説明したメールをお送りいたします。</strong>入金確認まではブロンズ会員として、ニューズ・オプエドをお楽しみください。</li>
                    </ul>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "RegistConfirm",
    mixins: [MultiModalMixin],
    data : function(){
      return {
        isLogged: OPED.isLogged,
        privacy_check : false,
      }
    },
    methods : {
      // $store.state.inputData.birthday
      dispBirthday(){
        return getBirthday(this.$store.state.inputData.birthday);
      },
      dispGender(){
        return getGenderName(this.$store.state.inputData.gender);
      },
      dispPlan(){
        let plan = this.$store.state.inputData.plan;
        switch (plan) {
          case 'bronze':
              return "ブロンズメンバー";
          case 'silver':
              return "シルバーメンバー";
          case 'gold':
              return "ゴールドメンバー";
          case 'platinum':
              return "プラチナメンバー（サロン）";
        }
      },
      dispCreditPrice(){
        let plan = this.$store.state.inputData.plan;
        let mm01 = this.$store.state.inputData.mm01;
        let mm02 = this.$store.state.inputData.mm02;
        return getPlanPrice(plan,mm01,mm02,1);
      },
      dispBankPrice(){
        let plan = this.$store.state.inputData.plan;
        let mm01 = this.$store.state.inputData.mm01;
        let mm02 = this.$store.state.inputData.mm02;
        let month = this.$store.state.inputData.bank_month;
        return getPlanPrice(plan,mm01,mm02,month);
      },

      send(){
        if(!this.isLogged){
          if(this.privacy_check){
            let params = {};
            params.last_name = this.$store.state.inputData.last_name;
            params.first_name = this.$store.state.inputData.first_name;
            params.email = this.$store.state.inputData.email;
            params.password = this.$store.state.inputData.password;
            params.phone = this.$store.state.inputData.phone;
            params.birthday = this.$store.state.inputData.birthday;
            params.gender = this.$store.state.inputData.gender;
            params.plan = this.$store.state.inputData.plan;
            params.mm01 = this.$store.state.inputData.mm01 ? true : false;
            params.mm02 = this.$store.state.inputData.mm02 ? true : false;
            params.payment = this.$store.state.inputData.payment_type;
            if(this.$store.state.inputData.payment_type == 'credit'){
              params.payment_token = this.$store.state.inputData.payment_token;
            }
            if(this.$store.state.inputData.payment_type == 'bank'){
              params.bankname = this.$store.state.inputData.bank_name;
              params.bankmonth = this.$store.state.inputData.bank_month;
            }
            $('#signup_submit').fadeOut(300);
            axios
              .post('/auth/regist',params)
              .then(response => {
                //if(response.status == 200){
                  this.showModalRegistThanks();
                //}
              })
              .catch(error => {
                alert('すでに会員登録されている可能性があります。お手数ですが、お問い合わせよりご確認ください')
                window.location.reload();
              })
          }
        }
      },
    },
    watch : {
      privacy_check (val) {
        if(val){
          $('#signup_submit').css('opacity',1);
        }else{
          $('#signup_submit').css('opacity',0.3);
        }
      },
    },
    mounted () {
      //console.log(this.$store.state.inputData.mm01);
    }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/regist_confirm.vue